import { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import ProjectAnalyticsCustomersSatisfaction from './ProjectAnalyticsCustomersSatisfaction';
import ProjectAnalyticsCustomersSentEmails from './ProjectAnalyticsCustomersSentEmails';
import ProjectAnalyticsCustomersSentSMS from './ProjectAnalyticsCustomersSentSMS';

interface ProjectAnalyticsCustomersProps {
  project: Project;
}

export const ProjectAnalyticsCustomers = ({ project }: ProjectAnalyticsCustomersProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const [currentView, setCurrentView] = useState<string>(``);

  const setLocationView = useCallback(
    (view: string) => {
      if (view !== currentView) {
        setCurrentView(view);
        navigate(`${view.replace(`:projectId`, `${project?.id}`)}`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentView, project?.id]
  );

  useEffect(() => {
    if (!!location && location.pathname !== ``) {
      if (
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_SMS.replace(`/h/:projectId`, ``)) === -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.CUSTOMERS.SENT_EMAILS.replace(`/h/:projectId`, ``)) === -1
      ) {
        setLocationView(routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION);
      }
    }
  }, [location, setLocationView]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/satisfaction" />} />

      <Route path="/satisfaction" element={<ProjectAnalyticsCustomersSatisfaction />} />
      <Route path="/sent-sms" element={<ProjectAnalyticsCustomersSentSMS />} />
      <Route path="/sent-emails" element={<ProjectAnalyticsCustomersSentEmails />} />
      <Route
        path="*"
        element={
          <Navigate to={`${routing.PROJECT_ANALYTICS.CUSTOMERS.SATISFACTION.replace(`:projectId`, project.id)}`} />
        }
      />
    </Routes>
  );
};
